<template>
    <div class="page">
        <div class="apply-title">支付聚合平台</div>
        <!-- 去新建应用页面 -->
        <el-button v-if="false" class="new" @click="updateMessage()">新建应用</el-button>
        <!-- 应用首页 -->
        <applyTop></applyTop>
        <!-- 应用模块 -->
        <applyContent :applyList="applyList"></applyContent>
    </div>
</template>

<script>
import { openDialog } from '@apply/static/mixin.js';
import { mapActions, mapGetters } from 'vuex';
import applyTop from '@apply/components/indexTop';
import applyContent from '@apply/components/applyContent';
export default {
  mixins: [openDialog],
  provide() {
    return {
      create: this.createApply,
      look: this.lookApply,
      add: this.addPay,
      edit: this.editApply,
      info: this.applayInfo,
    };
  },
  components: {
    applyTop,
    applyContent,
  },
  computed: {
    ...mapGetters('applyCreate', ['applyList']),
  },
  data() {
    return {
      companyId: '', //公司id
    };
  },
  methods: {
    ...mapActions('applyCreate', ['queryAllApply']),
    // 获取应用列表
    getAllApply() {
      this.queryAllApply({ companyId: this.companyId });
    },
    // 新建应用
    createApply() {
      this.$router.push({ name: 'apply/create' });
    },
    // 查看应用配置
    lookApply(item) {
      this.$router.push({ name: 'apply/detail', query: { id: item.id } });
    },
    // 继续配置
    addPay(item) {
      this.$router.push({ name: 'setup/channel' });
      localStorage.setItem('checkdApply', JSON.stringify(item));
    },
    // 编辑
    editApply(item) {
      this.$router.push({ name: 'apply/update', query: { id: item.id } });
    },
    // 跳转到应用详情
    applayInfo(item) {
      this.$router.push({ name: 'home' });
      localStorage.setItem('checkdApply', JSON.stringify(item));
    },
  },
  mounted() {
    this.companyId = JSON.parse(localStorage.getItem('loginUesr')).companyInfo.id;
    setTimeout(() => {
      this.getAllApply();
    }, 1000);
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.apply-title {
  width: calc(100% - 40px);
  font-size: 20px;
  font-weight: 500;
  color: #333;
  padding: 37px 20px;
  background: @bg-white;
  margin-bottom: 15px;
}
.new {
  position: absolute;
  top: 622px;
  right: 836px;
  width: 284px;
  height: 72px;
  border-radius: 10px;
  background: @primary-blue;
  color: #fff;
  font-size: 22px;
}
</style>
